import { Box, Typography, Icon } from '@bharatpe/bharat-ui';
import OrderStatusStepper from '@bharatpe/bharat-ui/web/OrderStatusStepper';
import React, { useEffect, useState } from 'react';
import TopArrow from 'assets/icons/Autopay/topArrow.svg';
import BottomArrow from 'assets/icons/Autopay/bottomRow.svg';
import SuccessIcon from 'assets/icons/Autopay/GreenTick.svg';
import PendingIcon from 'assets/icons/Autopay/Pending.svg';
import WaitingIcon from 'assets/icons/Autopay/PendingGrey.svg';
import { formatDate } from 'utils/Utils';
import './styles.scss';
import { logAnalyticsEvent } from 'utils/AnalyticsEvent';
import { useLanguageConfig } from 'Slices/LanguageConfigSlice';

const TrackDetails: React.FC<any> = ({ complaintDetails }) => {
	const [toggle, setToggle] = useState<boolean>(false);
	const [activeStep, setActiveStep] = useState<number>(0);
	const [registerDate, setRegisterDate] = useState<any>();
	const [resolutionDate, setResolutionDate] = useState<any>();
	const [closedDate, setClosedDate] = useState<any>();
	const { languageData } = useLanguageConfig();

	const trackingDetails = (index: number) => {
		let detailsDate: any = '';
		switch (index) {
			case 0:
				detailsDate = complaintDetails?.registered_date || '';
				setRegisterDate(detailsDate);
				setResolutionDate('');
				setClosedDate('');
				break;
			case 1:
				detailsDate = complaintDetails?.updated_at == '' ? Date.now() : complaintDetails?.registered_date;
				setResolutionDate(detailsDate);
				setRegisterDate(complaintDetails?.registered_date);
				setClosedDate('');
				break;
			case 2:
				detailsDate = complaintDetails?.updated_at;
				setClosedDate(detailsDate);
				setResolutionDate(complaintDetails.registered_date);
				setRegisterDate(complaintDetails.registered_date);
				break;
		}
	};
	useEffect(() => {
		if (complaintDetails) {
			if (complaintDetails.status == 'CLOSED') {
				setActiveStep(2);
			} else {
				if (complaintDetails.updated_at == '') {
					setActiveStep(0);
				} else {
					setActiveStep(1);
				}
			}
		}
		trackingDetails(activeStep);
	}, [complaintDetails]);

	const steps: any = [
		<div className="flex flex-justify" key={'raised'}>
			<Typography className="width-70 dark regular300">{languageData.COMPLAINT_RAISED}</Typography>
			<Typography className="width-30 dark light500 text-right">{formatDate(registerDate)}</Typography>
		</div>,
		<div className="flex flex-justify" key={'inprogress'}>
			<Typography className="width-70 dark regular300">{languageData.RESOLUTION_IN_PROCESS}</Typography>
			<Typography className="width-30 dark light500 text-right">{formatDate(resolutionDate)}</Typography>
		</div>,
		<div className="flex flex-justify" key={'resolved'}>
			<Typography className="width-70 dark regular300">{languageData.COMPLAINT_RESOLVED}</Typography>
			<Typography className="width-30 dark light500 text-right">{formatDate(closedDate)}</Typography>
		</div>,
	];

	const StepIcons = {
		1: <Icon icon={SuccessIcon} color="primary" width={16} height={16} />,
		2: <Icon icon={activeStep < 1 ? WaitingIcon : activeStep < 2 ? PendingIcon : SuccessIcon} width={16} height={16} />,
		3: <Icon icon={activeStep < 2 ? WaitingIcon : SuccessIcon} width={16} height={16} />,
	};

	const onToggleClick = () => {
		logAnalyticsEvent({
			trigger_point: 'Clicks on Track Details',
			Product: 'AutoPayUPI',
			Flow: 'UDIR',
			Screen: 'UDIR_Det',
			Module: 'Page',
			Element: 'Track_Details',
			Action: 'Tapped',
			source: 'appHeader',
			status: complaintDetails?.status,
			ctaType: toggle ? 'collapse' : 'expand',
		});
		setToggle(!toggle);
	};
	return (
		<Box className="secondary-background p2">
			<Box className="flex flex-row m2">
				<Box className="flex flex-start w-100 ml2">
					<Typography variant="SemiBold100" className="primary uppercase">
						{languageData.TRACK_DETAILS}
					</Typography>
				</Box>
				<Box className="flex flex-end ml2" onClick={() => onToggleClick()}>
					<img src={toggle ? TopArrow : BottomArrow} width={16} height={16} className="flex flex-end" />
				</Box>
			</Box>
			{!toggle && (
				<div className="secondary-background p2">
					<OrderStatusStepper
						steps={steps}
						activeStep={activeStep}
						icons={StepIcons}
						className="track"
						showPending={true}
					/>
				</div>
			)}
		</Box>
	);
};

export default TrackDetails;
